import { Text } from '@user-portal/wikr-components';
import React from 'react';

import * as S from './MealInstructions.styled';

type MealInstructionsProps = {
    instructions?: {
        position: number;
        text: string;
    }[];
    copy: {
        title: string;
    };
};

export const MealInstructions = ({ instructions, copy }: MealInstructionsProps) => {
    if (!instructions || instructions.length === 0) {
        return null;
    }

    return (
        <S.Section data-locator="meal-instructions-section" data-testid="meal-instructions-section">
            <Text type="medium-text" medium>
                {copy.title}
            </Text>
            <S.Container data-locator="meal-instructions" data-testid="meal-instructions">
                {instructions.map((instruction) => (
                    <S.Item key={instruction.position}>
                        <S.Step>
                            <Text type="medium-text" bold>
                                {instruction.position}
                            </Text>
                        </S.Step>
                        <Text type="option-subtitle-text" color="text-secondary">
                            {instruction.text}
                        </Text>
                    </S.Item>
                ))}
            </S.Container>
        </S.Section>
    );
};
